exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".preloader-backdrop{background-color:transparent}.page-preloader{background-color:#fff;box-shadow:0 5px 20px #d6dee4}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/app.component.css
// module id = ./ClientApp/app/app.component.css
// module chunks = main